import styled, { css } from "styled-components";

export const RichTextContainer = styled.div`
  padding: 16px 0;

  .MuiTiptap-FieldContainer-focused .MuiTiptap-FieldContainer-notchedOutline {
    border-bottom: 2px solid ${({ theme }) => theme.colors.primaryTextHover} !important;
  }

  .MuiTiptap-FieldContainer-notchedOutline {
    border: none;
  }

  ${({ disabled }) =>
    !disabled &&
    css`
      .MuiTiptap-FieldContainer-notchedOutline {
        border-bottom: 2px solid ${({ theme }) => theme.colors.primarySeparator};

        ${({ error }) =>
          error &&
          css`
            border-bottom: 2px solid ${({ theme }) => theme.colors.offTrackText} !important;
          `}
      }
    `}

  .MuiTiptap-FieldContainer-root:hover
    .MuiTiptap-FieldContainer-notchedOutline {
    box-shadow:
      0px 8px 16px 0px rgba(161, 153, 194, 0.2),
      0px 4px 8px 0px rgba(161, 153, 194, 0.16),
      0px 2px 4px 0px rgba(161, 153, 194, 0.12),
      0px 1px 2px 0px rgba(161, 153, 194, 0.08);
    border-bottom: 2px solid ${({ theme }) => theme.colors.primaryTextHover};
  }

  .MuiTiptap-RichTextContent-root {
    background-color: ${({ theme }) => theme.colors.neutralsWhiteTint85};
  }

  .MuiTiptap-MenuBar-root {
    background-color: ${({ theme }) => theme.colors.neutralsWhiteTint85};
    border-radius: 2px;
  }

  .editor {
    min-height: 165px;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      .MuiTiptap-RichTextContent-root {
        background-color: ${({ theme }) =>
          theme.colors.disabledInputBackground};
      }

      .MuiTiptap-MenuBar-root {
        background-color: ${({ theme }) =>
          theme.colors.disabledInputBackground};
        border-radius: 2px;
      }

      .MuiTiptap-FieldContainer-root:hover
        .MuiTiptap-FieldContainer-notchedOutline {
        box-shadow: none;
        border-bottom: 0;
      }
    `}

  .controls-container > hr {
    margin: 0;
    -webkit-flex-shrink: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    border-width: 0;
    border-style: solid;
    border-color: ${({ theme }) => theme.colors.neutralsBlack};
    border-bottom-width: 0;
    height: 100%;
    border-right-width: thin;
    height: 18px;
    margin: 0px 4px;
  }

  > span.error {
    display: block;
    height: 12px;
    ${({ theme }) => theme.fontStyles.InterfaceCopySmall}
    color: ${({ theme }) => theme.colors.offTrackText};
    padding-top: 4px;
  }
`;
